import { lazy } from "react";

/* Admin */
export const LazyAdminHomePage = lazy(() =>
  import("@/pages/admin/AdminHomePage").then((m) => ({ default: m.AdminHomePage })),
);
export const LazySalesPipelinePage = lazy(() =>
  import("@/pages/admin/SalesPipelinePage").then((m) => ({ default: m.SalesPipelinePage })),
);
export const LazyLeadDetailPage = lazy(() =>
  import("@/pages/admin/LeadDetailPage").then((m) => ({ default: m.LeadDetailPage })),
);
export const LazyReferenceLettersPage = lazy(() =>
  import("@/pages/admin/ReferenceLettersPage").then((m) => ({ default: m.ReferenceLettersPage })),
);
export const LazyClientsOrganizationsPage = lazy(() =>
  import("@/pages/admin/ClientsOrganizationsPage").then((m) => ({ default: m.ClientsOrganizationsPage })),
);
export const LazyOrganizationDetailPage = lazy(() =>
  import("@/pages/admin/OrganizationDetailPage").then((m) => ({ default: m.OrganizationDetailPage })),
);
export const LazyCapacityReportPage = lazy(() =>
  import("@/pages/admin/CapacityReportPage").then((m) => ({ default: m.CapacityReportPage })),
);
export const LazySendCapacityCheckPage = lazy(() =>
  import("@/pages/admin/SendCapacityCheckPage").then((m) => ({ default: m.SendCapacityCheckPage })),
);
export const LazyCapacityProspectsPage = lazy(() =>
  import("@/pages/admin/CapacityProspectsPage").then((m) => ({ default: m.CapacityProspectsPage })),
);
export const LazyGetStartedPage = lazy(() =>
  import("@/pages/public/GetStartedPage").then((m) => ({ default: m.GetStartedPage })),
);
export const LazyAssessmentPosterPage = lazy(() =>
  import("@/pages/public/AssessmentPosterPage").then((m) => ({ default: m.AssessmentPosterPage })),
);
export const LazyOrganizationEmployeeEditPage = lazy(() =>
  import("@/pages/admin/OrganizationEmployeeEditPage").then((m) => ({ default: m.OrganizationEmployeeEditPage })),
);
export const LazyEditOrganizationPage = lazy(() =>
  import("@/pages/admin/EditOrganizationPage").then((m) => ({ default: m.EditOrganizationPage })),
);
export const LazyCurriculumBundleHistoryPage = lazy(() =>
  import("@/pages/admin/CurriculumBundleHistoryPage").then((m) => ({ default: m.CurriculumBundleHistoryPage })),
);
export const LazyCreateOrganizationPage = lazy(() =>
  import("@/pages/admin/CreateOrganizationPage").then((m) => ({ default: m.CreateOrganizationPage })),
);
export const LazyCreateUserPage = lazy(() =>
  import("@/pages/admin/CreateUserPage").then((m) => ({ default: m.CreateUserPage })),
);
export const LazyStaffUsersPage = lazy(() =>
  import("@/pages/admin/StaffUsersPage").then((m) => ({ default: m.StaffUsersPage })),
);
export const LazySettingsPage = lazy(() =>
  import("@/pages/admin/SettingsPage").then((m) => ({ default: m.SettingsPage })),
);

/* Org portal */
export const LazyOrgStudioPage = lazy(() =>
  import("@/pages/org/OrgStudioPage").then((m) => ({ default: m.OrgStudioPage })),
);
export const LazyEmployeeListPage = lazy(() =>
  import("@/pages/org/EmployeeListPage").then((m) => ({ default: m.EmployeeListPage })),
);
export const LazyOrgEmployeeAddRedirect = lazy(() =>
  import("@/pages/org/OrgEmployeeAddRedirect").then((m) => ({ default: m.OrgEmployeeAddRedirect })),
);
export const LazyEmployeeDetailPage = lazy(() =>
  import("@/pages/org/EmployeeDetailPage").then((m) => ({ default: m.EmployeeDetailPage })),
);
export const LazyOrgEmployeeEditPage = lazy(() =>
  import("@/pages/org/OrgEmployeeEditPage").then((m) => ({ default: m.OrgEmployeeEditPage })),
);
export const LazyImportEmployeesPage = lazy(() =>
  import("@/pages/org/ImportEmployeesPage").then((m) => ({ default: m.ImportEmployeesPage })),
);
export const LazyOrgadminDashboardPage = lazy(() =>
  import("@/pages/org/OrgadminDashboardPage").then((m) => ({ default: m.OrgadminDashboardPage })),
);
export const LazyManagerDashboardPage = lazy(() =>
  import("@/pages/org/ManagerDashboardPage").then((m) => ({ default: m.ManagerDashboardPage })),
);
export const LazyOrgEmployeeHomePage = lazy(() =>
  import("@/pages/org/OrgEmployeeHomePage").then((m) => ({ default: m.OrgEmployeeHomePage })),
);
export const LazyOrgAssessmentEntryPage = lazy(() =>
  import("@/pages/org/OrgAssessmentEntryPage").then((m) => ({ default: m.OrgAssessmentEntryPage })),
);

/* Team member app */
export const LazyEmployeePortalPage = lazy(() =>
  import("@/pages/my/EmployeePortalPage").then((m) => ({ default: m.EmployeePortalPage })),
);
export const LazyEmployeeSelfCarePage = lazy(() =>
  import("@/pages/my/EmployeeSelfCarePage").then((m) => ({ default: m.EmployeeSelfCarePage })),
);
export const LazyEmployeeSelfCareRegionPage = lazy(() =>
  import("@/pages/my/EmployeeSelfCareRegionPage").then((m) => ({ default: m.EmployeeSelfCareRegionPage })),
);
export const LazyEmployeePhaseProgramPage = lazy(() =>
  import("@/pages/my/EmployeePhaseProgramPage").then((m) => ({ default: m.EmployeePhaseProgramPage })),
);
export const LazyFunctionalCapacityPage = lazy(() =>
  import("@/pages/my/FunctionalCapacityPage").then((m) => ({ default: m.FunctionalCapacityPage })),
);

/* Assessments / public-app surfaces reused inside auth */
export const LazyAssessmentSetupWizardPage = lazy(() =>
  import("@/pages/public/AssessmentSetupWizardPage").then((m) => ({ default: m.AssessmentSetupWizardPage })),
);
export const LazyCapacityAssessmentPage = lazy(() =>
  import("@/pages/public/CapacityAssessmentPage").then((m) => ({ default: m.CapacityAssessmentPage })),
);

/* Misc authenticated */
export const LazyBodyMapPage = lazy(() =>
  import("@/pages/BodyMapPage").then((m) => ({ default: m.BodyMapPage })),
);
export const LazyMapsOverviewPage = lazy(() =>
  import("@/pages/MapsOverviewPage").then((m) => ({ default: m.MapsOverviewPage })),
);
export const LazyEmployeeMapsPage = lazy(() =>
  import("@/pages/EmployeeMapsPage").then((m) => ({ default: m.EmployeeMapsPage })),
);
export const LazyEmployeeTestingPage = lazy(() =>
  import("@/pages/EmployeeTestingPage").then((m) => ({ default: m.EmployeeTestingPage })),
);

/* Studio bundle author / consumption */
export const LazyVideoLibraryPage = lazy(() =>
  import("@/pages/studio/VideoLibraryPage").then((m) => ({ default: m.VideoLibraryPage })),
);
export const LazyVideoDetailPage = lazy(() =>
  import("@/pages/studio/VideoDetailPage").then((m) => ({ default: m.VideoDetailPage })),
);
export const LazyExerciseLibraryPage = lazy(() =>
  import("@/pages/studio/ExerciseLibraryPage").then((m) => ({ default: m.ExerciseLibraryPage })),
);
export const LazyTemplateLibraryPage = lazy(() =>
  import("@/pages/studio/TemplateLibraryPage").then((m) => ({ default: m.TemplateLibraryPage })),
);
export const LazyTemplateFormPage = lazy(() =>
  import("@/pages/studio/TemplateFormPage").then((m) => ({ default: m.TemplateFormPage })),
);
export const LazySelfCareListPage = lazy(() =>
  import("@/pages/studio/SelfCareListPage").then((m) => ({ default: m.SelfCareListPage })),
);
export const LazySelfCareEditorPage = lazy(() =>
  import("@/pages/studio/SelfCareEditorPage").then((m) => ({ default: m.SelfCareEditorPage })),
);
export const LazyBundleListPage = lazy(() =>
  import("@/pages/studio/BundleListPage").then((m) => ({ default: m.BundleListPage })),
);
export const LazyBundleWizardPage = lazy(() =>
  import("@/pages/studio/BundleWizardPage").then((m) => ({ default: m.BundleWizardPage })),
);
export const LazyBundleDetailPage = lazy(() =>
  import("@/pages/studio/BundleDetailPage").then((m) => ({ default: m.BundleDetailPage })),
);
export const LazyStudioPlayerPage = lazy(() =>
  import("@/pages/studio/StudioPlayerPage").then((m) => ({ default: m.StudioPlayerPage })),
);

/** Shared by `/my/player/template/...` and studio player routes — one chunk per module. */
export const LazyStudioTemplatePlayerPage = lazy(() =>
  import("@/pages/studio/StudioTemplatePlayerPage").then((m) => ({ default: m.StudioTemplatePlayerPage })),
);

/* Truly public routes (minimal initial bundle — auth stays eager) */
export const LazyAssessmentIntakePage = lazy(() =>
  import("@/pages/public/AssessmentIntakePage").then((m) => ({ default: m.AssessmentIntakePage })),
);
export const LazyLeadCapturePage = lazy(() =>
  import("@/pages/public/LeadCapturePage").then((m) => ({ default: m.LeadCapturePage })),
);
export const LazyPublicPlayerPage = lazy(() =>
  import("@/pages/public/PublicPlayerPage").then((m) => ({ default: m.PublicPlayerPage })),
);
